module.exports = require('./countries.json')
